import { gql } from 'apollo-angular';

import { PRODUCT_SELECTOR_VARIABLES_FRAGMENT } from 'graphql/fragments/product-selector-variables';

import { CONFIGURATION_VARIABLE_FRAGMENT } from './configuration-variable';

export const PRODUCT_SELECTOR_FRAGMENT = gql`
  fragment ProductSelectorFragment on ProductLine {
    id
    product {
      name
    }
    configuration @include(if: $withConfiguration) {
      vtzFile: variable(id: $vtzFileId) {
        values(filter: {isAssigned: true}) {
          name
          value
          assigned
        }
      }
      datamodelVersion: variable(id: $datamodelVersionId) {
        version: property(name: "CalculatedValue") { valueText }
      }
      frameImage: variable(id: $frameImageId) {
        values(filter: { isAssigned: true }) {
          image: property(name: "Image") { valueText }
        }
      }
      element: variable(id: $elementFilterId) {
        ...ConfigurationVariableFragment
      }
      type: variable(id: $typeFilterId) {
        ...ConfigurationVariableFragment
      }
      section(id: $filtersId) {
        sections {
          id
          name
          showProp: property(name: "Show") { valueText }
          sections {
            id
            name
            showProp: property(name: "Show") { valueText }
            sections {
              id
              name
              ...ProductSelectorVariablesFragment
            }
            ...ProductSelectorVariablesFragment
          }
        }
      }
    }
  }
  ${PRODUCT_SELECTOR_VARIABLES_FRAGMENT}
  ${CONFIGURATION_VARIABLE_FRAGMENT}
`;
